var map = {
	"./1_Glossary_+_Number_Checks.PNG": 1255,
	"./2_Glossary_Opposite_terms.PNG": 1256,
	"./3_Language_rules_+_Glossary_+_Verification.PNG": 1257,
	"./4_QA_reviewer.PNG": 1258,
	"./iQube at the heart Example.PNG": 1259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1254;